import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type UserRole = 'superadmin' | 'admin' | 'dispatch' | 'recruiter' | 'accounting' | 'maintenance' | 'Superadmin' | 'Admin' | 'Dispatch' | 'Dispatch Manager' | 'Safety' | 'Safety Manager' | 'Maintenance' | 'Accounting' | 'Accounting Manager' | 'Afterhours' | 'ELD' | 'Recruiting';

// Who may see dispatch money: load rates, driver pay, dispatcher gross and cut.
// Gates the Dispatchers Gross page and every dollar figure on the Dispatch Board,
// so the two can't drift apart. The owner asked that only admins and accounting
// see these numbers — not dispatch, safety or anyone else.
// Display names — also listed in the access notice on the Dispatchers Gross page.
export const DISPATCH_MONEY_ROLE_LABELS = ['Superadmin', 'Admin', 'Accounting', 'Accounting Manager'];
const DISPATCH_MONEY_ROLES = DISPATCH_MONEY_ROLE_LABELS.map((r) => r.toLowerCase());

export const canSeeDispatchMoney = (role: string | null | undefined): boolean =>
  DISPATCH_MONEY_ROLES.includes((role || '').trim().toLowerCase());

export interface Profile {
  id: string;
  email: string;
  full_name: string;
  role: UserRole;
  phone?: string;
  notification_email?: string | null;
  avatar_url?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}
